var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell-renderer-download icon-wrapper"},[_c('font-awesome-icon',{staticClass:"download-icon",class:_vm.iconClass,attrs:{"icon":[_vm.iconType, _vm.icon]},on:{"click":_vm.clicked}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }